<template>
  <div class="surveillance-list">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small >
            <span v-if="!isNational">
              {{ region }}
            </span>
            <span v-else>
              Programme National
            </span>
            {{ year }}
          </small>
          <br>
          {{ title }}
        </h1>
        <hr>
      </div>
    </div>

    <sui-table :columns="table.columns"
         ref="table"
         :actions="table.actions"
         :keyfield="table.keyfield"
         :initialSort="table.initialSort"
         :title="exportTitle"
         :list="formattedList"
         :selected="selected"
         :filterGen="filters"
         :filter="filter"
         :filterVariables="filterVariables"
         :formatter="formatter"
         :caracteristicsBuilder="caracteristicsBuilder"

         @remove="askForRemoval($event)"
         @convention="showConventionModal($event)"
         @referent="showReferentModal($event)"
         @establishment="showEstablishmentModal($event)"
         @members="showMembersModal($event)"
         @reaSink="showReaSinkModal($event)"
         @reaExplaur="showReaExplaurModal($event)"
         @datasets="showDatasetsModal($event)"
         @edit="showEditModal($event)">
      <template slot="actions">
        <div class="form-group">
          <c-checkbox v-model="showUfs" type="bactADI" size="sm">
            Ufs
          </c-checkbox>
        </div>
        <div class="form-group">
          <c-checkbox v-model="showSheets" type="results" size="sm">
            Fiches
          </c-checkbox>
        </div>
        <div class="form-group">
          <btn type="warning" @click="exportList" class="form-group">
            Export csv
          </btn>
        </div>

        <save-blob :target="csv.target"></save-blob>
      </template>
    </sui-table>
    <modal v-model="removeModal"
           @hide="removeModalEnded"
           title="Confirmation"
           ok-text="Oui" cancel-text="Non"
           ok-type="danger" cancel-type="primary">
      <p v-if="removeModal">
        Êtes vous certain.e de vouloir supprimer l'inscription
        de l'établissement {{ surveillance.establishment.name }} ?
      </p>
    </modal>

    <div v-if="surveillance">
      <convention-modal v-model="conventionModal"
                   :surveillance="surveillance" />
      <referent-modal v-model="referentModal"
                      v-if="user.isUser"
                      :surveillance="surveillance" />
      <establishment-modal v-model="establishmentModal"
                      v-if="user.isUser"
                      :surveillance="surveillance" />
      <members-modal v-model="membersModal"
                     :surveillance="surveillance" />
      <rea-sink-modal v-model="reaSinkModal"
                      v-if="user.isUser"
                      :surveillance="surveillance" />
      <rea-explaur-modal v-model="reaExplaurModal"
                      v-if="user.isUser"
                      :surveillance="surveillance" />
      <datasets-modal v-model="datasetsModal"
                      :surveillance="surveillance" />

      <sui-establishment-edit v-model="editModal"
                              v-if="user.isUser && editModal && surveillance != null"
                              :surveillance="surveillance"
                              :moduleList="moduleList"
                              event="surveillances/updateSubscription">
      </sui-establishment-edit>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import stringify from 'csv-stringify'
import moment from 'moment'

import suiTable from '@/sui/components/table'
import checkbox from '@/sui/components/checkbox'
import conventionModal from '@/components/surveillance/conventionmodal'
import suiEstablishmentEdit from '@/sui/components/establishment/edit'
import referentModal from '@/components/surveillance/referentmodal'
import establishmentModal from '@/components/surveillance/establishmentmodal'
import datasetsModal from '@/components/surveillance/datasetsmodal'
import membersModal from '@/components/surveillance/membersmodal'
import reaSinkModal from '@/components/surveillance/reasinkmodal'
import reaExplaurModal from '@/components/surveillance/reaexplaurmodal'
import filters from '@/tools/surveillance/filters'
import saveBlob from '@/sui/components/saveblob'
import impl from '@/views/surveillance/impl/list'
import modules from '@/sui/data/modules'
import { etbType } from '@/sui/data/flatten/common'
import regions from '@/sui/tools/regions'

export default {
  name: 'surveillance-list',

  mounted () {
    this.$store.dispatch('surveillances/all', this.year)
  },

  props: {
    year: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      title: `Inscriptions`,
      surveillance: null,
      conventionModal: false,
      editModal: false,
      referentModal: false,
      establishmentModal: false,
      membersModal: false,
      removeModal: false,
      reaSinkModal: false,
      reaExplaurModal: false,
      datasetsModal: false,
      showUfs: false,
      showSheets: false,
      sheetsDownloaded: false,
      selected: {
        field: 'closed',
        value: 'Oui'
      },
      filter: '',
      csv: {
        target: null
      },
      formatter: {
        estbSheetStatus: impl.getSingleSheetsStatus,
        toolsUsageSheetStatus: impl.getSingleSheetsStatus,
        conventionStatus: impl.getConventionStatus,
        bactADIValue: impl.booleanIcons,
        expADIValue: impl.booleanIcons,
        reaInfADIValue: impl.booleanIcons,
        diaInfADIValue: impl.booleanIcons,
        neoInfADIValue: impl.booleanIcons,
        reaBactADIValue: impl.booleanIcons,
        observa4Value: impl.booleanIcons,
        reaSinkValue: impl.booleanIcons,
        reaExplaurValue: impl.booleanIcons,
        topCvpValue: impl.booleanIcons,
        badiCauseValue: impl.booleanIcons,
        spy4Value: impl.booleanIcons
      }
    }
  },

  computed: {

    ...mapState({
      all: state => state.surveillances.all,
      sheets: state => state.bosheet.all,
      sheetsAvailable: state => state.bosheet.allAvailable
    }),

    ...mapGetters({
      user: 'login/loginState',
      loginRegion: 'login/region'
    }),

    hasSheets: function () {
      return this.sheetsAvailable && this.showSheets && this.sheetsDownloaded
    },

    isNational: function () {
      return this.$route.path.match(/^\/mission/)
    },

    region: function () {
      if (this.isNational || this.loginRegion == null) {
        return null
      }

      return regions.regions[this.loginRegion].name
    },

    exportTitle: function () {
      const r = this.isNational ? 'PROGRAMME NATIONAL' : this.region
      return `SPIADI${this.year} - ${r} - INSCRIPTIONS`
    },

    moduleList: function () {
      return modules.get(this.year, (m) => m.sheets)
    },

    filters: function () {
      const result = []
      filters[this.year].forEach(
        f => {
          if (f.active == null || f.active(this.user)) {
            result.push(f)
          }
        }
      )
      return result
    },

    filterVariables: function () {
      return impl.filterVariables[this.year]
    },

    table: function () {
      return impl.buildTable(
        this.year, this.showUfs, this.user, this.hasSheets
      )
    },

    caracteristicsBuilder: function () {
      return impl.caracteristicsBuilder(this.year)
    },

    formattedList: function () {
      const list = this.all[this.year]
      const reducer = (result, s) => {
        const name = s.establishment.name
        const town = s.establishment.town
        const finess = s.establishment.finess
        const emails = s.registrator.emails
        const et = s.establishment.type
        const estbType = et > 0 ? etbType(et) : ''
        const v = {
          id: s.id,
          source: s,
          registration: moment(s.registration),
          filterlabel: `${name} ${finess} ${emails}`,
          establishment: name,
          finess: finess,
          town: town,
          region: regions.getRegion(finess).name,
          refName: `${s.registrator.firstName} ${s.registrator.name}`,
          referent: emails,
          conventionStatus: s.cvt.stat,
          estbSheetStatus: s.establishment.shst,
          toolsUsageSheetStatus: s.toolsUsage.shst,
          estbType: estbType
        }

        for (let m in this.moduleList) {
          v[m] = s.hasProtocol(m)
          if (v[m] && this.hasSheets) {
            const sheets = this.sheets.find(
              sh => sh.protocol === m && sh.surveillance === s.id
            )
            v[`${m}Sheets`] = (sheets != null) ? 'Oui' : 'Non'
          }

          impl.buildModule(v, s, m, this.year)
          if (impl.listValues[m]) {
            impl.listValues[m](v, s)
          }
        }

        if (s.year >= 2019) {
          if (v.conventionStatus === 2 && v.estbSheetStatus === 'valid') {
            const r = new RegExp(/^Oui[^p]*([^\]]*)\]?$/, 'i')
            let has = false
            let pfd = false
            let npfd = false
            for (let m in this.moduleList) {
              if (m === 'reaSink' ||
                  m === 'observa4' ||
                  m === 'reaExplaur' ||
                  m === 'topCvp' ||
                  m === 'badiCause' ||
                  m === 'spy4'
              ) {
                continue
              }

              const l = v[`${m}Value`].match(r)
              if (l == null) {
                continue
              }

              has = true

              if (l[1] === 'pfd') {
                pfd = true
              } else {
                npfd = true
              }
            }

            if (has) {
              v.endStatus = pfd ? (npfd ? 'POK' : 'OK') : 'NOK'
            }
          }
        }

        result.push(v)
        return result
      }

      return list.reduce(reducer, [])
    }
  },

  watch: {
    year: function (value, old) {
      if (value !== old) {
        this.$store.dispatch('surveillances/all', value)
        this.filter = ''
        this.sheetsDownloaded = false
        this.showSheets = false
      }
    },

    showSheets: function (value, old) {
      if (value && !old && !this.sheetsDownloaded) {
        const begin = new Date(this.year - 1, 11, 1, 12)
        const end = moment().add(1, 'day').endOf('day')

        const vm = this
        this.$store.dispatch(
          'bosheet/all',
          {
            b: begin,
            e: end.toDate()
          }
        ).then(
          r => {
            vm.sheetsDownloaded = r.data.err == null
            vm.showSheets = vm.sheetsDownloaded
            if (!vm.showSheets) {
              vm.$notify({
                type: 'danger',
                title: 'Erreur !',
                content: `Impossible de télécharger les informations sur les fiches : ${r.data.err}.`
              })
            }
          }
        ).catch(e => {
          vm.showSheets = false
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            content: `Impossible de télécharger les informations sur les fiches : ${e.data ? e.data : e}.`
          })
        })
      }
    },

    all: {
      handler: function (value) {
        if (this.surveillance == null) {
          return
        }
        this.surveillance = value[this.year].find(e => {
          return e.id === this.surveillance.id
        })
      },
      deep: true
    }
  },

  methods: {
    askForRemoval: function (s) {
      this.removeModal = true
      this.surveillance = s.source
    },

    removeModalEnded: function (msg) {
      if (msg === 'ok') {
        this.remove(this.surveillance)
      }
      this.surveillance = null
    },

    remove: function (s) {
      const { id, year } = s
      let instance = this
      this.$store.dispatch(`surveillances/remove`, { i: id, y: year }).then(
        (response) => {
          if (response.data.err == null) {
            instance.$notify({
              type: 'success',
              title: 'Succès !',
              content: `Inscription ${id} supprimée avec succès.`
            })
            instance.$store.dispatch(`surveillances/all`, year)
          } else {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible de supprimer l'inscription ${id}: ${response.data.err}.`
            })
          }
        }).catch(function (e) {
        instance.$notify({
          type: 'danger',
          title: 'Erreur !',
          content: `Impossible de supprimer l'inscription ${id}: ${e}.`
        })
      })
    },

    showModal: function (s, f) {
      this.surveillance = s.source
      this[`${f}Modal`] = true
    },

    showReaSinkModal: function (s) {
      this.showModal(s, 'reaSink')
    },

    showReaExplaurModal: function (s) {
      this.showModal(s, 'reaExplaur')
    },

    showConventionModal: function (s) {
      this.showModal(s, 'convention')
    },

    showReferentModal: function (s) {
      this.showModal(s, 'referent')
    },

    showEstablishmentModal: function (s) {
      this.showModal(s, 'establishment')
    },

    showMembersModal: function (s) {
      this.showModal(s, 'members')
    },

    showEditModal: function (s) {
      this.showModal(s, 'edit')
    },

    showDatasetsModal: function (s) {
      this.showModal(s, 'datasets')
    },

    exportList: function (e) {
      const vm = this
      const t = this.$refs.table
      const f = t.data.filter
      const filter = f === '' ? '' : ` - FILTRE «${f}»`
      stringify(
        t.formattedList,
        {
          bom: true,
          header: true,
          delimiter: ';',
          columns: impl.exportColumns[this.year],
          cast: {
            boolean: function (b, ctx) {
              return { value: b ? 'Oui' : 'Non', quote: false }
            },

            string: function (v, col, t) {
              const clean = v.replace(/<\/?small>|<br ?\/>$|Non$/gi, '')
              return clean.replace(/<br ?\/>/gi, ' ')
            }
          }
        },

        function (err, output) {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                vm.csv.target = {
                  filename: `${vm.exportTitle}${filter}.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    }
  },

  components: {
    'c-checkbox': checkbox,
    'sui-table': suiTable,
    'convention-modal': conventionModal,
    'sui-establishment-edit': suiEstablishmentEdit,
    'rea-sink-modal': reaSinkModal,
    'rea-explaur-modal': reaExplaurModal,
    'datasets-modal': datasetsModal,
    'referent-modal': referentModal,
    'establishment-modal': establishmentModal,
    'members-modal': membersModal,
    'save-blob': saveBlob
  }
}
</script>

<style lang="less" scoped>
.c-checkbox {
  vertical-align: middle;
}
</style>
